import { Flex, Image, Text } from '@podiumhq/design-system';
import { motion } from 'framer-motion';

import avatar from '../../assets/webchat-avatar.png';
import { getPopAnimationProps } from '../../utils';
import PodiumLogo from 'components/PodiumLogo';

const Webchat = () => (
  <Flex flexDir="column">
    <motion.div
      {...getPopAnimationProps(1.5, 0.5)}
      style={{ transformOrigin: 'bottom left' }}
    >
      <Flex
        w="284px"
        borderRadius="24px"
        p="16px"
        bg="silver.lightest"
        borderBottomLeftRadius="0px"
        alignItems="center"
      >
        <Image src={avatar} alt="webchat avatar" w="56px" h="56px" mr="18px" />
        <Text color="black.base">Have a question? Text us here!</Text>
      </Flex>
    </motion.div>
    <motion.div
      {...getPopAnimationProps(1, 0.5)}
      style={{ transformOrigin: 'bottom left' }}
    >
      <Flex
        w="40px"
        h="40px"
        borderRadius="50%"
        mt="8px"
        bg="white"
        alignItems="center"
        justifyContent="center"
      >
        <PodiumLogo icon={true} maxWidth="14px" />
      </Flex>
    </motion.div>
  </Flex>
);

export default Webchat;
